import { isBrowser } from '../utils/is-browser.js';

// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function () {
  return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
  return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
  return isBrowser && window.onmousedown === null;
};
export { supportsMouseEvents, supportsPointerEvents, supportsTouchEvents };